export default __webpack_public_path__ + "static/media/airport.c5d82cea.jpeg";